export default __webpack_public_path__ + "static/retail-add-to-calendar-0e20e3012d9c7803ee0bdce72431a46f.png";